"use client";
import "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import {
  CpslButton,
  CpslDivider,
  CpslIcon,
  CpslIdenticon,
  CpslQrCode,
  CpslSpinner,
  CpslText
} from "@getpara/react-components";
import { CenteredText, FilledDisabledInput, InnerStepContainer, QRContainer } from "../common.js";
import { isMobile, WalletType } from "@getpara/web-sdk";
import { useModalStore, useThemeStore } from "../../stores/index.js";
import { useCopyToClipboard } from "@getpara/react-common";
import { useMemo } from "react";
import { useActiveWallet } from "../../hooks/useActiveWallet.js";
import { useAddFunds } from "./AddFundsContext.js";
import { formatNetworkList } from "../../utils/stringFormatters.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const GENERIC_WALLET = {
  [WalletType.EVM]: "Ethereum or EVM-based networks",
  [WalletType.SOLANA]: "Solana or SVM-based networks",
  [WalletType.COSMOS]: "Cosmos networks"
};
function AddFundsReceive() {
  const [isCopied, copy] = useCopyToClipboard();
  const { networks } = useAddFunds();
  const para = useInternalClient();
  const appName = useThemeStore((state) => state.appName);
  const hideWallets = useThemeStore((state) => state.hideWallets);
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const activeWallet = useActiveWallet();
  const address = useMemo(
    () => activeWallet ? para.getDisplayAddress(activeWallet.id, { addressType: activeWallet.type }) : "",
    [para, activeWallet == null ? void 0 : activeWallet.id, activeWallet == null ? void 0 : activeWallet.type]
  );
  const onCopy = () => {
    copy(address);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(InnerStepContainer, { children: /* @__PURE__ */ jsxs(
      FilledDisabledInput,
      {
        noAutoDisable: true,
        readonly: true,
        placeholder: para.getDisplayAddress(activeWallet.id, {
          truncate: true,
          addressType: activeWallet.type,
          targetLength: 16
        }),
        children: [
          /* @__PURE__ */ jsx(CpslIdenticon, { slot: "start", size: "32px", hash: para.getIdenticonHash(activeWallet.id, activeWallet.type) }),
          /* @__PURE__ */ jsx(CpslButton, { slot: "end", variant: "ghost", onClick: onCopy, children: /* @__PURE__ */ jsx(CpslIcon, { icon: isCopied ? "check" : "copy" }) })
        ]
      },
      address
    ) }),
    !isMobile() && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(CpslDivider, { children: "or" }),
      /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
        /* @__PURE__ */ jsx(QRContainer, { children: !address ? /* @__PURE__ */ jsx(CpslSpinner, { size: 100 }) : /* @__PURE__ */ jsx(CpslQrCode, { url: address }, address) }),
        /* @__PURE__ */ jsx(CpslText, { weight: "semiBold", color: "secondary", children: "Scan with your crypto wallet" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsxs(CenteredText, { weight: "semiBold", children: [
        !!onRampConfig.allowedAssets && networks.length > 0 || hideWallets ? appName != null ? appName : "This App" : "This Wallet",
        " ",
        "Only Supports:"
      ] }),
      /* @__PURE__ */ jsx(CenteredText, { weight: "medium", color: "secondary", children: !!onRampConfig.allowedAssets && networks.length > 0 ? formatNetworkList(networks) : GENERIC_WALLET[activeWallet.type] })
    ] })
  ] });
}
export {
  AddFundsReceive
};
